import { Box, Flex, RadioButton, Text } from '@auviknetworks/iceberg-ui';
import { Alert } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { IntegrationMethodIcon } from '../../Avatars/IntegrationMethodIcon';
import {
    INTEGRATION_OPTION_GOOGLE_AUTOMATED,
    INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_AUTOMATED
} from '../Components/IntegrationSelector';
import { Step } from '../Forms/components/Step';

const OptionCard = ({ checked, intro, title, type, setChecked }) => {
    const theme = useTheme();
    return (
        <Flex
            data-testid="chooseIntegrationOptionCard"
            flexDirection="column"
            p={3}
            backgroundColor={theme.palette.background.optionIntegration}
            justifyContent="space-between"
            alignItems="stretch"
            m={2}
            width={['100%', '100%', '100%', '100%', '50%']}
        >
            <RadioButton checked={checked} onChange={() => setChecked()} />
            <Flex
                data-testid="onboardingQuickScanSelectSubCard"
                flexDirection="column"
                alignItems="stretch"
                height="100%"
                p={2}
                onClick={() => setChecked()}
            >
                <IntegrationMethodIcon type={type} />
                <Flex flexDirection="column" alignItems="stretch" height="100%">
                    <Text
                        fontSize={3}
                        color={theme.palette.text.secondary}
                        textAlign="center"
                        my={3}
                    >
                        {title}
                    </Text>
                    <Text
                        fontSize={1}
                        color={theme.palette.text.secondary}
                        my={3}
                        dangerouslySetInnerHTML={{ __html: intro }}
                    />
                </Flex>
            </Flex>
        </Flex>
    );
};

const defaultOnSuccessFn = () => {};

export const ChooseIntegration = ({
    integrationType,
    setIntegrationType,
    useIntegrationWizard = true,
    handleProviderSelection = defaultOnSuccessFn,
    formFooterComponent
}) => {
    const { t } = useTranslation();
    return (
        <Box
            display="flex"
            flexDirection="column"
            height="100%"
            justifyContent="space-between"
        >
            <Box p="24px" m="0" width="100%">
                <Box mb="16px">
                    <Alert
                        severity="warning"
                        icon={false}
                        sx={{ justifyContent: 'center' }}
                    >
                        {t('Clients.integration.billingDisclaimer')}
                    </Alert>
                </Box>
                {!useIntegrationWizard ? (
                    <Step
                        number="2"
                        details={t('Clients.addModal.steps.1')}
                        margins="0px"
                    />
                ) : (
                    <Text fontSize={3}>{t('Clients.addModal.steps.1')}</Text>
                )}
                <Flex
                    alignItems="stretch"
                    data-testid="chooseIntegration"
                    flexDirection="row"
                    mt={2}
                >
                    <OptionCard
                        checked={
                            integrationType ===
                            INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_AUTOMATED
                        }
                        intro={t(
                            'Onboarding.quickScanSelectStep.microsoftEntraID.intro'
                        )}
                        title={t(
                            'Onboarding.quickScanSelectStep.microsoftEntraID.title'
                        )}
                        type="microsoftEntraID"
                        setChecked={() => {
                            setIntegrationType(
                                INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_AUTOMATED
                            );
                            handleProviderSelection(
                                INTEGRATION_OPTION_MICROSOFT_ENTRA_ID_AUTOMATED
                            );
                        }}
                    />
                    <OptionCard
                        checked={
                            integrationType ===
                            INTEGRATION_OPTION_GOOGLE_AUTOMATED
                        }
                        intro={t('Onboarding.quickScanSelectStep.google.intro')}
                        title={t('Onboarding.quickScanSelectStep.google.title')}
                        type="google"
                        setChecked={() => {
                            setIntegrationType(
                                INTEGRATION_OPTION_GOOGLE_AUTOMATED
                            );
                            handleProviderSelection(
                                INTEGRATION_OPTION_GOOGLE_AUTOMATED
                            );
                        }}
                    />
                </Flex>
            </Box>
            <Box>{formFooterComponent}</Box>
        </Box>
    );
};
